import type { SDSInputErrorMessageProps } from '@repo/sds/SDSInputErrorMessage';
import { SDSInputErrorMessage } from '@repo/sds/SDSInputErrorMessage';
import { SDSInputLabel, type SDSInputLabelProps } from '@repo/sds/SDSInputLabel';

import type {
  Option,
  SelectOptionValue,
  SingleChoiceDropdownProps,
} from '../SingleChoiceDropdown/SingleChoiceDropdown';
import { SingleChoiceDropdown } from '../SingleChoiceDropdown/SingleChoiceDropdown';

type SingleChoiceDropdownWithLabelProps<T extends SelectOptionValue = string> = Omit<
  SingleChoiceDropdownProps<T>,
  'onChange'
> &
  Pick<Required<SDSInputLabelProps>, 'label'> &
  SDSInputLabelProps &
  Omit<SDSInputErrorMessageProps, 'dataTestId'> & {
    onChange: (option: Option<T> | null) => void;
    errorMessageTestId?: string;
  };

export function SingleChoiceDropdownWithLabel<T extends SelectOptionValue = string>(
  props: SingleChoiceDropdownWithLabelProps<T>,
) {
  const {
    name,
    label,
    isRequired,
    errorMessage,
    errorMessageTestId,
    width = '100%',
    onChange,
    ariaLabel = label,
    ...otherProps
  } = props;

  return (
    <label htmlFor={name} style={{ width }}>
      <SDSInputLabel label={label} isRequired={isRequired} />
      <SingleChoiceDropdown name={name} onChange={onChange} ariaLabel={ariaLabel} {...otherProps} />
      <SDSInputErrorMessage errorMessage={errorMessage} dataTestId={errorMessageTestId} />
    </label>
  );
}
